import Loadable from 'react-loadable';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import authActions from '@/redux/auth/actions';
import { Loader } from '@/components';

const AsyncProfile = Loadable({
  loader: () => import('./Profile'),
  loading: Loader,
});

const mapStateToProps = (state, ownProps) => ({
  initialValues: {
    firstName: ownProps.auth.profile.first_name,
    lastName: ownProps.auth.profile.last_name,
    email: ownProps.auth.profile.email,
    phone: ownProps.auth.profile.phone_number,
    image: ownProps.auth.profile.image,
    organization: ownProps.auth.profile.organization,
  },
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      updateUser: authActions.updateUser,
      updateOrganization: authActions.updateOrganization,
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(AsyncProfile);
